import React from "react";
import "./Homepage.css";
const Homepage = () => {
  return (
    <div className="homepage container">
      <div class="">
        <img
          className="img-fliud w-100 "
          src="https://www.trendingus.com/wp-content/uploads/2019/12/c1946e59f3f121584adce33f9133133d.jpeg"
          alt=""
        />
        <div class="hero-text">
          <h1>In Our School you can</h1>
          <p>Learn the best driving techniqe.</p>
          <button>Join Us</button>
        </div>
      </div>
      <div>
        <h2 className="text-center mt-3">Service</h2>
        <hr className="w-25 m-auto " />
      </div>
      <div class="row row-cols-1 row-cols-md-3 g-4 mt-5">
        <div class="col-md-3">
          <div class="card h-100">
            <img
              className="img-fluid"
              src="https://d1ix0byejyn2u7.cloudfront.net/drive/images/uploads/headers/ws_cropper/1_0x0_790x520_0x520_intensive_driving_courses.jpg"
              class="card-img-top"
              alt="..."
            />
            <div class="card-body">
              <h5 class="card-title">Car Driving Course</h5>
              <p class="card-text">
                Unlimited practice tests included with purchase. 100% permit
                exam pass rate. Convenient—take anywhere, anytime, on any
                device.
              </p>
              <p>Price:20$</p>
            </div>
          </div>
        </div>
        <div class="col-md-3">
          <div class="card h-100">
            <img
              className="img-fluid"
              src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTp0L4l9DJjbcTZDhPQMWYIZ8ytHvqZC_9rXw&usqp=CAU"
              class="card-img-top"
              alt="..."
            />
            <div class="card-body">
              <h5 class="card-title">Sporty Driving Courses</h5>
              <p class="card-text">
                Unlimited practice tests included with purchase. 100% permit
                exam pass rate. Convenient—take anywhere, anytime, on any
                device.
              </p>
              <p>Price:20$</p>
            </div>
          </div>
        </div>
        <div class="col-md-3">
          <div class="card h-100">
            <img
              className="img-fluid "
              src="https://humber.ca/education-training-solutions/assets/images/transportation-training/trucking-courses-new.jpg;wa107d0bfb5da922a4"
              class="card-img-top"
              alt="..."
            />
            <div class="card-body">
              <h5 class="card-title">Trucks Driving Course</h5>
              <p class="card-text">
                Unlimited practice tests included with purchase. 100% permit
                exam pass rate. Convenient—take anywhere, anytime, on any
                device.
              </p>
              <p>Price:20$</p>
            </div>
          </div>
        </div>
        <div class="col-md-3">
          <div class="card h-100">
            <img
              className=" img-fluid"
              src="https://i.ytimg.com/vi/RZNU-g0GcP8/maxresdefault.jpg"
              class="card-img-top"
              alt="..."
            />
            <div class="card-body">
              <h5 class="card-title">Motorcycles Driving Course</h5>
              <p class="card-text">
                Unlimited practice tests included with purchase. 100% permit
                exam pass rate. Convenient—take anywhere, anytime, on any
                device.
              </p>
              <p>Price:20$</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Homepage;
